import { BaseField, BaseFieldModel } from '../baseField';
import { FieldType } from '../fieldType';

export interface CheckboxRuleModel {
  when: string;
}

export interface CheckboxFieldModel extends BaseFieldModel {
  defaultValue: boolean;
  type: FieldType.CheckBox;
  rules?: CheckboxRuleModel[];
}

export class CheckboxField extends BaseField implements CheckboxFieldModel {
  public defaultValue = false;
  public type: FieldType.CheckBox = FieldType.CheckBox;

  constructor(cultures: string[]) {
    super(FieldType.CheckBox, cultures);
  }
}
